<template>
  <div id="rewards">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Claimed Rewards</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="rewards"
            :search="search"
            :items-per-page="20"
          >
            <template v-slot:item.date="{ item }">
              <h4>{{ item.date | moment('timezone', timezone, " h:mm:ss a") }}</h4>
              {{ item.date | moment('timezone', timezone, " Do MMMM YYYY") }}
            </template>
            <template v-slot:item.amount="{ item }">${{ (item.amount/100).toFixed(2) }}</template>
            <template v-slot:item.expiry="{ item }">
              {{ item.expiry | moment('timezone', timezone, " Do MMMM YYYY") }}
            </template>
            <template v-slot:item.transaction.balance="{ item }">${{ (item.transaction.balance/100).toFixed(2) }}</template>
            <template
              v-slot:item.name="{ item }"
            >{{ item.user.firstname + ' ' + item.user.lastname }}</template>
          </v-data-table>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Rewards",
  data() {
    return {
      search: '',
      rewards: [],
      headers: [
        { text: "Date", value: "date", align: "start" },
        { text: "Amount", value: "amount" },
        { text: "GiftPay ID", value: "gift_id" },
        { text: "GiftPay Status", value: "status.Message" },
        { text: "Expiry", value: "expiry" },
        { text: "Region", value: "region" },
        { text: "Transaction Reference", value: "transaction.reference" },
        { text: "Balance at Time of Purchase", value: "transaction.balance" },
        { text: "Type", value: "transaction.category" },
        { text: "Name", value: "name" },
        { text: "Email", value: "user.email" }
      ]
    };
  },
  mounted() {
    this.getRewards();
    this.getTimezone();
  },
  computed: {},
  methods: {
    getRewards() {
      if (this.rewards == "undefined" || this.rewards.length < 1) {
        this.$store.dispatch("retrieveAdminRewards").then(() => {
          this.rewards = this.$store.getters.adminRewards;
        });
      }
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
</style>